import type { LinkProps } from '@mui/material/Link';

import { forwardRef } from 'react';
import { mergeClasses } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import { logoClasses } from './classes';
import { CONFIG } from '../../global-config';

// ----------------------------------------------------------------------

export type LogoProps = LinkProps & {
  isDark?: boolean;
  disabled?: boolean;
  withLink?: boolean;
  isSingle?: boolean;
};

export const Logo = forwardRef<HTMLAnchorElement, LogoProps>((props, ref) => {
  const {
    className,
    href = '/',
    isDark = true,
    withLink = true,
    isSingle = false,
    disabled,
    sx,
    ...other
  } = props;

  const emblemDark = (
    <img
      alt="Smedex logo"
      src={`${CONFIG.assetsDir}/logo/emblem-dark.svg`}
      width="100%"
      height="100%"
    />
  );

  const logoDark = (
    <img
      alt="Smedex logo"
      src={`${CONFIG.assetsDir}/logo/logo-dark.svg`}
      width="100%"
      height="100%"
    />
  );

  const logoLight = (
    <img
      alt="Smedex logo"
      src={`${CONFIG.assetsDir}/logo/logo-light.svg`}
      width="100%"
      height="100%"
    />
  );

  const logoContent = isSingle ? emblemDark : isDark ? logoDark : logoLight;

  const commonSx = [
    () => ({
      width: isSingle ? 40 : 125,
      height: isSingle ? 40 : 25,
      ...(disabled && { pointerEvents: 'none' }),
    }),
    ...(Array.isArray(sx) ? sx : [sx]),
  ];

  if (!withLink) {
    return (
      <LogoContainer className={mergeClasses([logoClasses.root, className])} sx={commonSx}>
        {logoContent}
      </LogoContainer>
    );
  }

  return (
    <LogoRoot
      ref={ref}
      component={RouterLink}
      href={href}
      aria-label="Logo"
      underline="none"
      className={mergeClasses([logoClasses.root, className])}
      sx={commonSx}
      {...other}
    >
      {logoContent}
    </LogoRoot>
  );
});

const LogoRoot = styled(Link)(() => ({
  flexShrink: 0,
  color: 'transparent',
  display: 'inline-flex',
  verticalAlign: 'middle',
}));

const LogoContainer = styled(Box)(() => ({
  flexShrink: 0,
  color: 'transparent',
  display: 'inline-flex',
  verticalAlign: 'middle',
}));
